import "core-js/modules/es.number.constructor.js";
//
//
//

export default {
  name: 'vip-level',
  props: {
    level: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  methods: {}
};